import type { ReactNode } from 'react';
import { GlobalSidebar } from './GlobalSidebar';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <GlobalSidebar />
      <div className="lg:ml-64 flex flex-col min-h-screen">
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
}